// extracted by mini-css-extract-plugin
module.exports = {"Layout":"Layout_Layout__37MHr","Left":"Layout_Left__3OBTh","Right":"Layout_Right__1o79n"};